export type AddTransitionAutoCancelInput = {
  source: string | null | undefined;
  target: string | null | undefined;
  possibleMethodCount: number;
};

/**
 * Whether the add-transition form should close itself because there is
 * nothing to pick.
 *
 * Only a live add (both endpoints still set) with zero applicable methods
 * auto-cancels. After the parent has already closed and cleared source/target,
 * a fresh empty methods list must not call onCancel again — that loop is
 * React error #185 (production stack: setEdges).
 */
export function shouldAutoCancelAddTransition(
  input: AddTransitionAutoCancelInput
): boolean {
  if (input.source == null || input.target == null) return false;
  return input.possibleMethodCount === 0;
}
